/**
 * Mixin to handle the creation / destruction of a `paginated list container`.
 * 
 * After a page of results has already been rendered, a `paginted list container`
 * is meant to attach to DOM mount point and load subsequent pages via ajax.
 * 
 * This mixin has been extracted from logic based on the Artist Filter Form, to
 * eventually be shared with similar forms.
 * 
 * Note: the purpose of thismixin was to extract common logic to shared amongst
 * similar forms; it is out of scope to redo pagination implementation.
 */
import Vue from 'vue';
import { MoMABalanceText } from 'sol';

import { buildGet } from 'Utils/ajax';
import PaginationListContainer from 'Components/paginated-list/paginated-list-container.vue';
import PaginationCallbacks from 'Components/paginated-list/pagination-callbacks.js';

export default {
  components: {
    PaginationListContainer,
  },

  props: {
    dataFetchBaseURL: { type: String, required: true },
    dataLastPage: { type: Number, required: true },
    dataShowMoreItemsButtonHTML: { type: String, required: true },
  },

  data() {
    return {
      balanceText: new MoMABalanceText(),

      lastPage: this.dataLastPage,
      showSpinner: false,
    };
  },

  methods: {
    displaySpinner() {
      this.showSpinner = true;
    },

    hideSpinner() {
      this.showSpinner = false;
    },

    /**
     * Fetch filtered results.
     *
     * @param {string} url
     */
    async fetchData(url) {
      const headers = new Headers({ 'Content-Type': 'text/plain', 'X-Requested-With': 'XMLHttpRequest' });
      const res = await fetch(url, { headers: headers })
        .then(res => {
          // TODO: handle this legacy artifical delay better
          return new Promise((resolve) => {
            setTimeout(() => resolve(res), 250);
          });
        })
        .then(res => {
          this.filteredTotal = Number(res.headers.get("x-filtered-total"));
          this.lastPage = Number(res.headers.get("x-last-page"));
          return res.text();
        })
        .catch(error => {
          console.error('Error:', error);
        });

      return res;
    },

    populatePaginationResults(res) {
      const insertionPoint = document.querySelector('[data-pagination-insertion]');
      insertionPoint.innerHTML = res;
      this.balanceText.balance(insertionPoint.getElementsByClassName('balance-text'));
    },

    displayPaginationContainer() {
      const container = document.querySelector('[data-pagination-container]');
      container.style.opacity = 1;
    },

    hidePaginationContainer() {
      const container = document.querySelector('[data-pagination-container]');
      container.style.transition = "opacity 250ms";
      container.style.opacity = 0;
    },

    addPagination(url, params) {
      let el = document.querySelector('[data-pagination-insertion]');

      const callback = new PaginationCallbacks({ el: el });
      const paginationBefore = callback.before.bind(callback);
      const paginationAfter = callback.after.bind(callback);
      new Vue({
        el: '[data-pagination-mount]',
        data: {
          dynamicComponent: PaginationListContainer,
          currentPage: 1,
          lastPage: this.lastPage,
          showMoreItemsButtonHTML: this.dataShowMoreItemsButtonHTML,

          get: buildGet(url),
          getSetupFunc: paginationBefore,
          getCompletionFunc: paginationAfter,
          params: params,
        },
        template:
          `
          <component
            :is=dynamicComponent
            :initialCurrentPage=currentPage
            :initialLastPage=lastPage
            :showMoreItemsButtonHTML=showMoreItemsButtonHTML
            :fetchPaginatedListFunc=get
            :fetchPaginatedListSetupFunc=getSetupFunc
            :fetchPaginatedListCompletedFunc=getCompletionFunc
            :params=params
          />
        `
      });
    },

    removePagination(){
      const paginationMount = document.querySelector('[data-pagination-mount]');
      paginationMount.innerHTML = "";
    },
  },
};
